
export const farm = {
  'farm.profileTitle': 'Profil Numérique de la Ferme',
  'farm.profileSubtitle': 'Profil numérique complet pour votre ferme',
  'farm.clientProfileTitle': 'Profil de Ferme Client',
  'farm.clientProfileSubtitle': 'Profil numérique complet pour la ferme de votre client',
  'farm.assistantTitle': 'Assistant AgriBot',
  'farm.assistantDesc': 'Posez des questions ou fournissez des informations supplémentaires',
  'farm.assistantPlaceholder': 'Tapez des informations supplémentaires sur votre ferme...',
  'farm.assistantResponse': 'Merci ! Cette mise à jour aide à améliorer votre alignement avec deux programmes de subventions.',
  'farm.documentTitle': 'Coffre-fort de Documents',
  'farm.documentSubtitle': 'Téléchargez et gérez les documents de la ferme',
  'farm.regulatoryOverview': 'Aperçu Réglementaire',
  'farm.capCompliance': 'Conforme à la PAC',
  'farm.emissionsScore': 'Score d\'Émissions',
  'farm.ecoSchemeEligibility': 'Éligible au Programme Éco',
  'farm.aiUpdates': 'Récentes Mises à jour IA du Profil',
  'farm.aiUpdateInitial': "Nous avons mis à jour votre profil de durabilité pour refléter les nouvelles pratiques de compostage.",
  'farm.aiUpdateResponse': 'Cette information a été ajoutée à votre profil.',
  'farm.regionOpportunityScore': 'Score d\'Opportunité Régionale',
  'farm.grantDensity': 'Densité de Subventions',
  'farm.politicalFriendliness': 'Convivialité Politique',
  'farm.recentApprovals': 'Approbations Récentes',
  'farm.high': 'Élevé',
  'farm.medium': 'Moyen',
  'farm.veryHigh': 'Très Élevé',
  'farm.low': 'Bas',
  'farm.attachedSubsidies': 'Subventions Attachées',
  'farm.manuallyAttached': 'Attachées Manuellement',
  'farm.automaticallyMatched': 'Jumelées Automatiquement'
} as const;
